import { capitalize } from '@mui/material/utils';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
const languageNames = new Intl.DisplayNames(['en'], { type: 'language' });
export const transformLanguage = (profile) => {
    const lang = profile.locale ? languageNames.of(profile.locale.replace('_', '-')) || '' : '';
    return {
        label: 'Language',
        value: lang,
        emptyValueMessage: 'Add Your Preferred Language'
    };
};
export const transformFullName = (profile) => {
    const fullName = [profile.prefix, profile.firstName, profile.middleName, profile.lastName, profile.suffix]
        .filter((name) => name !== undefined)
        .map((name) => capitalize(name))
        .join(' ');
    return {
        label: 'Name',
        value: fullName
    };
};
export const transformUsername = (email) => ({
    label: 'Username/Email',
    value: email,
    emptyValueMessage: 'Add your email address. This will serve as your login email.'
});
export const transformPhoneNumber = (profile) => {
    let formattedPhoneNumber = '';
    const { countryCode, areaCode, phoneNumber } = profile;
    if (countryCode && areaCode && phoneNumber) {
        const parsedNumber = parsePhoneNumberFromString(`${areaCode}${phoneNumber}`, { defaultCallingCode: countryCode });
        if (parsedNumber === null || parsedNumber === void 0 ? void 0 : parsedNumber.isValid()) {
            formattedPhoneNumber = parsedNumber.formatInternational();
        }
    }
    return {
        label: 'Phone Number',
        value: formattedPhoneNumber,
        emptyValueMessage: 'Add your phone number'
    };
};
